import axios from "axios";
import { useRef, useState } from "react";
import Swal from "sweetalert2";
import useDeviceType from "../useDeviceType";

export default function BottomBar() {
  const [phone1, setPhone1] = useState<string>("010");
  const [phone2, setPhone2] = useState<string>("");
  const [phone3, setPhone3] = useState<string>("");
  const [agree, setAgree] = useState<boolean>(true);

  const phone2Ref = useRef<HTMLInputElement>(null);
  const phone3Ref = useRef<HTMLInputElement>(null);

  const onlyNumber = (value: string) => value.replace(/[^0-9]/g, "");

  const isMobile = useDeviceType();

  const handlerPostContact = async () => {
    const phone = `${phone1}${phone2}${phone3}`;

    if (!phone2 || !phone3) {
      Swal.fire({
        title: "연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.startsWith("010")) {
      Swal.fire({
        title: "010을 포함한 연락처를 정확히 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (!agree) {
      Swal.fire({
        title: "개인정보 수집에 동의해주세요.",
        icon: "error",
      });
      return false;
    }

    await axios
      .post("/api/contact/quick", {
        phone: phone,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-10 border-t border-black/10 bg-white shadow-[0_-4px_20px_rgba(0,0,0,0.12)]">
      <div className="flex flex-col items-stretch md:flex-row md:items-center md:gap-5">
        {/* Left + Center: consultation info and form */}
        <div className="flex flex-1 flex-col items-stretch gap-2 py-2.5 md:flex-row md:items-center md:gap-6 lg:gap-8 px-[calc((100%-var(--container))/3)] md:pr-6">
          {/* Phone banner (desktop) */}
          <a href="tel:010-8123-8285" className="hidden shrink-0 lg:block">
            <img
              src={"/images/num.png"}
              alt="무료견적 365일 24시간 긴급출동 010.8123.8285"
              className="h-9 w-auto lg:h-10 xl:h-12"
            />
          </a>

          {/* Form */}
          <div className="w-full">
            <label className="flex cursor-pointer items-center gap-1.5 text-[11px] text-gray-500 md:text-xs mb-1.5">
              <input
                type="checkbox"
                checked={agree}
                defaultChecked
                // onChange={(e) => setAgree(e.target.checked)}
                className="h-3.5 w-3.5 shrink-0 accent-red"
              />
              상담을 위한 개인정보 수집에 동의합니다
            </label>
            <form
              className="flex w-full items-center gap-2 md:gap-3"
              onSubmit={(e) => {
                e.preventDefault();
                handlerPostContact();
              }}
            >
              <div className="flex flex-1 items-center gap-1.5 md:gap-2">
                <input
                  type="tel"
                  inputMode="numeric"
                  value={phone1}
                  maxLength={3}
                  onChange={(e) => {
                    const v = onlyNumber(e.target.value);
                    setPhone1(v);
                    if (v.length === 3) phone2Ref.current?.focus();
                  }}
                  placeholder="010"
                  className="w-full min-w-0 flex-1 rounded-sm border border-gray-300 bg-white py-2 text-center text-sm text-font placeholder:text-gray-400 focus:border-red focus:outline-none focus:ring-1 focus:ring-red"
                />
                <span className="text-gray-400">-</span>
                <input
                  ref={phone2Ref}
                  type="tel"
                  inputMode="numeric"
                  value={phone2}
                  maxLength={4}
                  onChange={(e) => {
                    const v = onlyNumber(e.target.value);
                    setPhone2(v);
                    if (v.length === 4) phone3Ref.current?.focus();
                  }}
                  placeholder="0000"
                  className="w-full min-w-0 flex-1 rounded-sm border border-gray-300 bg-white py-2 text-center text-sm text-font placeholder:text-gray-400 focus:border-red focus:outline-none focus:ring-1 focus:ring-red"
                />
                <span className="text-gray-400">-</span>
                <input
                  ref={phone3Ref}
                  type="tel"
                  inputMode="numeric"
                  value={phone3}
                  maxLength={4}
                  onChange={(e) => setPhone3(onlyNumber(e.target.value))}
                  placeholder="0000"
                  className="w-full min-w-0 flex-1 rounded-sm border border-gray-300 bg-white py-2 text-center text-sm text-font placeholder:text-gray-400 focus:border-red focus:outline-none focus:ring-1 focus:ring-red"
                />
              </div>

              <button
                type="submit"
                className="shrink-0 whitespace-nowrap rounded-sm bg-red px-5 md:px-6 py-2 text-sm font-bold text-white transition-colors hover:brightness-95"
              >
                전송
              </button>
            </form>
          </div>
        </div>

        {/* Right: emergency banner (bleeds to screen edge, desktop only) */}
        <div
          onClick={() => (window.location.href = "tel:010-8123-8285")}
          className="flex items-center justify-center gap-2 bg-red lg:pr-[calc((100%-var(--container))/3)] text-white md:justify-start"
        >
          <span className="relative inline-block overflow-hidden animate-bounce-soft md:py-5 lg:py-6 lg:px-5">
            <img
              className="object-contain lg:max-h-16"
              src={isMobile ? "/images/quickMo.png?v=2" : "/images/quickBar.png?v=2"}
              alt="수도권 전지역 긴급출동"
            />
            <span
              className="pointer-events-none absolute inset-y-0 left-0 w-1/3 animate-shine-full bg-gradient-to-r from-transparent via-white/70 to-transparent"
              aria-hidden="true"
            />
          </span>
        </div>
      </div>
    </div>
  );
}
